import { render, staticRenderFns } from "./spareGetAddNew.vue?vue&type=template&id=7f6ecbf0&scoped=true"
import script from "./spareGetAddNew.vue?vue&type=script&lang=js"
export * from "./spareGetAddNew.vue?vue&type=script&lang=js"
import style0 from "./spareGetAddNew.vue?vue&type=style&index=0&id=7f6ecbf0&prod&lang=scss&scoped=true"
import style1 from "./spareGetAddNew.vue?vue&type=style&index=1&id=7f6ecbf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6ecbf0",
  null
  
)

export default component.exports